import styled from "styled-components";
import { motion } from "framer-motion";

export const ImgLoaderContainer = styled(motion.img)`
    height: 100%;
    width: 100%;

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
`